<template>
  <v-expand-transition>
    <slot></slot>
  </v-expand-transition>
</template>

<script>
export default {
  name: "AppExpandTransition",
};
</script>

<style scoped></style>
